<template>
  <div class="field-text position-relative">
    <!-- Label del campo (si showLabel es true) -->
    <small
      v-if="showLabel && field.label"
      :for="computedFieldId"
      class="form-label w-100"
    >
      <strong>
        {{ $t(field.label) }}
      </strong>
    </small>
    <br v-if="showLabel && field.label" />

    <!-- MODO FILTRO -->
    <FilterFieldText
      v-if="mode === 'edit' && isFilter"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :filterOperator="filterOperator"
      @input="$emit('input', $event)"
      @filter-operator-change="$emit('filter-operator-change', $event)"
    />

    <!-- MODO EDIT -->
    <EditFieldText
      v-else-if="effectiveFieldMode === 'edit'"
      :field="field"
      :value="value"
      :valuePath="valuePath"
      :localeValues="localeValues"
      :fieldId="computedFieldId"
      :editingFields="editingFields"
      :disableLock="disableLock"
      :calculated="calculated"
      @input="$emit('input', $event)"
      @sibling-input="$emit('sibling-input', $event)"
      @update:editingFields="$emit('update:editingFields', $event)"
    />

    <!-- MODO VIEW -->
    <ViewFieldText
      v-else-if="effectiveFieldMode === 'view'"
      :field="field"
      :value="value"
      :item="item"
      :modelName="modelName"
      :isGroupModel="isGroupModel"
      :compactTextarea="compactTextarea"
      @go-to-blnumber="$emit('go-to-blnumber', $event)"
    />
  </div>
</template>

<script>
import EditFieldText from "./text/editField.vue";
import ViewFieldText from "./text/viewField.vue";
import FilterFieldText from "./text/filterField.vue";
import fieldEditableByMixin from "@/mixins/fieldEditableByMixin";

export default {
  name: "FieldText",
  mixins: [fieldEditableByMixin],
  components: {
    EditFieldText,
    ViewFieldText,
    FilterFieldText,
  },
  props: {
    // Definición del campo
    field: {
      type: Object,
      required: true,
    },
    // Valor actual del campo
    value: {
      type: [String, Number, Array, Object],
      default: null,
    },
    /** Path en FormV2 engine para siblings i18n (name_es, …) */
    valuePath: {
      type: String,
      default: null,
    },
    /** Valores por locale ya resueltos desde el form engine */
    localeValues: {
      type: Object,
      default: () => ({}),
    },
    // Modo: 'edit' o 'view'
    mode: {
      type: String,
      required: true,
      validator: (value) => ["edit", "view"].includes(value),
    },
    // ID único del campo (para modo edit)
    fieldId: {
      type: String,
      default: null,
    },
    // Para campos safe: indica si el campo está siendo editado
    editingFields: {
      type: String,
      default: "",
    },
    // Item completo (para modo view, especialmente para name/title)
    item: {
      type: Object,
      default: null,
    },
    // Nombre del modelo (para modo view)
    modelName: {
      type: String,
      default: "",
    },
    // Si es un grupo modelo (para modo view)
    isGroupModel: {
      type: Boolean,
      default: false,
    },
    // Si debe mostrar el label del campo
    showLabel: {
      type: Boolean,
      default: false,
    },
    // Si debe deshabilitar el candado (útil para filtros)
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
    // Si es un filtro (muestra operadores integrados)
    isFilter: {
      type: Boolean,
      default: false,
    },
    compactTextarea: {
      type: Boolean,
      default: false,
    },
    // Operador del filtro (solo si isFilter es true)
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    // ID del campo (genera uno si no se proporciona)
    computedFieldId() {
      return this.fieldId || `field-text-${this.field.key}`;
    },
  },
};
</script>

<style scoped>
.field-text {
  width: 100%;
}
</style>
